// extracted by mini-css-extract-plugin
export default {"wrapper":"Landing_wrapper__-i+Oj"};